import { type InstallationId, type SubFamily, type SubFamilyId } from "@/features/sub-families/types";
import type { Nullable } from "@/types";

export const getAllInstallations = (subFamilies: SubFamily[]) => {
    const installations = new Map<InstallationId, string>();

    for (const subFamily of subFamilies) {
        const { installationTypes } = subFamily;

        for (const installationType of installationTypes) {
            if (!installationType) continue;

            const { id, name } = installationType;

            installations.set(id, name);
        }
    }

    return Object.fromEntries(installations) as Record<InstallationId, string>;
};

export const getInitialInstallationId = (
    subFamilyId: SubFamilyId,
    subFamilies: SubFamily[],
    installations: Record<InstallationId, string>,
): Nullable<InstallationId> => {
    const fallbackId = (Object.keys(installations)[0] ?? null) as Nullable<InstallationId>;

    const subFamily = subFamilies.find(({ id }) => id === subFamilyId) ?? null;
    if (!subFamily) return fallbackId;

    return subFamily.installationTypes[0]?.id ?? fallbackId;
};
